import { fetcher } from '@commenda/utils';
import type {
  ICreatePolicyDocumentVersionParams,
  ICreatePolicyDocumentVersionResponse,
  TCreatePolicyDocumentVersionResult,
} from './types';

const FALLBACK_ERROR_MESSAGE = 'Could not save the version. Please try again.';

const readServerMessage = (body: unknown): string | undefined => {
  if (typeof body !== 'object' || body === null || !('message' in body)) {
    return undefined;
  }
  const { message } = body;
  if (typeof message === 'string') return message;
  if (Array.isArray(message) && typeof message[0] === 'string') {
    return message[0];
  }
  return undefined;
};

const isCreateResponse = (
  body: unknown
): body is ICreatePolicyDocumentVersionResponse =>
  typeof body === 'object' &&
  body !== null &&
  'documentVersion' in body &&
  typeof body.documentVersion === 'object' &&
  body.documentVersion !== null;

export const createPolicyDocumentVersion = async (
  policyId: string,
  params: ICreatePolicyDocumentVersionParams,
  token?: string
): Promise<TCreatePolicyDocumentVersionResult> => {
  try {
    const response = await fetcher(
      `transfer-pricing/policy/${policyId}/document-version`,
      { method: 'POST', body: params },
      token
    );
    const body: unknown = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        success: false,
        error: readServerMessage(body) ?? FALLBACK_ERROR_MESSAGE,
        status: response.status,
      };
    }
    if (!isCreateResponse(body)) {
      return { success: false, error: FALLBACK_ERROR_MESSAGE, status: null };
    }

    return { success: true, data: body };
  } catch (error) {
    console.error(error);
    return { success: false, error: FALLBACK_ERROR_MESSAGE, status: null };
  }
};
